<script setup>
const versionLabel = process.env.VUE_APP_VERSION || "dev";
const currentYear = new Date().getFullYear();
</script>

<template>
  <footer class="app-footer border-top bg-light">
    <div class="container py-3">
      <div class="d-flex flex-column flex-md-row align-items-center justify-content-between gap-2">
        <div class="small text-muted">
          &copy; {{ currentYear }} Nerdforce
        </div>

        <nav class="d-flex flex-wrap justify-content-center gap-3 small" aria-label="Rechtliche Hinweise">
          <router-link class="link-secondary text-decoration-none" :to="{ name: 'LegalImprint' }">
            Impressum
          </router-link>
          <router-link class="link-secondary text-decoration-none" :to="{ name: 'LegalPrivacy' }">
            Datenschutz
          </router-link>
          <router-link class="link-secondary text-decoration-none" :to="{ name: 'LegalTerms' }">
            Nutzungsbedingungen
          </router-link>
          <router-link class="link-secondary text-decoration-none" :to="{ name: 'ReleaseNotes' }">
            Version {{ versionLabel }}
          </router-link>
        </nav>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style scoped>
.app-footer {
  flex-shrink: 0;
}
</style>
